import { render, staticRenderFns } from "./CriarContaPinbank.vue?vue&type=template&id=3068d14d"
import script from "./CriarContaPinbank.vue?vue&type=script&lang=js"
export * from "./CriarContaPinbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports